var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclairagePublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 6.45054L25.9994 2.45054H21.9994L19.9994 6.45054L9.99939 12.4505H13.9994L15.9994 28.4505L19.9994 32.4505L20.9994 34.4505H17.9994V46.4505H29.9994V34.4505H26.9994L27.9994 32.4505L31.9994 28.4505L33.9994 12.4505H37.9994L27.9994 6.45054ZM28.3194 26.4505H19.6794L17.9994 12.4505H29.9994L28.3194 26.4505Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclairagePublic);
export default __webpack_public_path__ + "static/media/EclairagePublic.901c1a9582eac95beedf661ebd3b3b04.svg";
export { ForwardRef as ReactComponent };